var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightModeCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.347 0.869565C4.347 0.389318 4.73632 0 5.21657 0C5.69682 0 6.08614 0.389318 6.08614 0.869565V1.73958H13.0423V0.869565C13.0423 0.389318 13.4316 0 13.9119 0C14.3921 0 14.7814 0.389318 14.7814 0.869565V1.73958H14.7826C17.1838 1.73958 19.1304 3.68617 19.1304 6.08741V7.82552V9.56465V15.6526C19.1304 18.0539 17.1838 20.0005 14.7826 20.0005H4.34783C1.94659 20.0005 0 18.0539 0 15.6526V9.56465V7.82552V6.08741C0 3.68644 1.94614 1.74003 4.347 1.73958V0.869565ZM4.347 3.47871C2.90664 3.47916 1.73913 4.64694 1.73913 6.08741V7.82552H17.3913V6.08741C17.3913 4.64667 16.2234 3.47871 14.7826 3.47871H14.7814V5.21739C14.7814 5.69764 14.3921 6.08696 13.9119 6.08696C13.4316 6.08696 13.0423 5.69764 13.0423 5.21739V3.47871H6.08614V5.21739C6.08614 5.69764 5.69682 6.08696 5.21657 6.08696C4.73632 6.08696 4.347 5.69764 4.347 5.21739V3.47871ZM17.3913 15.6526V9.56465H1.73913V15.6526C1.73913 17.0934 2.90708 18.2613 4.34783 18.2613H14.7826C16.2234 18.2613 17.3913 17.0934 17.3913 15.6526ZM4.78351 12.1745C4.06314 12.1745 3.47917 12.7585 3.47917 13.4788C3.47917 14.1992 4.06314 14.7832 4.78351 14.7832H14.3487C15.0691 14.7832 15.6531 14.1992 15.6531 13.4788C15.6531 12.7585 15.0691 12.1745 14.3487 12.1745H4.78351Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeCalendarIcon);
export default __webpack_public_path__ + "static/media/LightModeCalendarIcon.5f8b52addf4c1f93cbfe7c66d8aec45b.svg";
export { ForwardRef as ReactComponent };